import TutorialSection from './onboarding-tutorial-section'

export default TutorialSection
